import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const SettingsTab = ({ setting }) => {
  const location = useLocation()

  const isActive = setting.exact
    ? location.pathname === setting.link
    : location.pathname.includes(setting.link)

  return (
    <Link
      key={setting.link}
      to={setting.link}
      className={`flex items-center py-[12px] transition-all duration-200 ease ${isActive ? 'px-[12px] bg-white rounded-lg' : ''}`}
    >
      <img src={setting.icon} alt={setting.label} className="w-[24px] h-[24px]" draggable={false} />

      <span
        className={`ml-[12px] text-primary-100 text-[13px] leading-[20px] ${isActive ? 'font-bold' : 'font-normal'}`}
      >
        {setting.label}
      </span>
    </Link>
  )
}

export default SettingsTab
